import lineStyle from './xAxis.axisTick.lineStyle'

export default {
  name: "axisTick",
  nickname: "坐标轴刻度",
  desc: "坐标轴刻度相关设置。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示坐标轴刻度。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    alignWithLabel: {
      name: "alignWithLabel",
      nickname: "alignWithLabel",
      desc:
        '类目轴中在 <code class="codespan">boundaryGap</code> 为 <code class="codespan">true</code> 的时候有效，可以保证刻度线和标签对齐。如下图：',
      value: false,
      defaultValue: false,
    },
    interval: {
      name: "interval",
      nickname: "间隔",
      desc:
        '坐标轴刻度的显示间隔，在类目轴中有效。默认同 <a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.axisLabel.interval">axisLabel.interval</a> 一样。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    inside: {
      name: "inside",
      nickname: "内部",
      desc: "坐标轴刻度是否朝内，默认朝外。",
      value: false,
      defaultValue: false,
    },
    length: {
      name: "length",
      nickname: "长度",
      desc: "坐标轴刻度的长度。",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    lineStyle,
  },
}
